<template>
  <session class="mobile-page-claims js-page-claims">
    <Header />
    <Banner :title="bannerTitle" :content="bannerContent" :cover="IMG_BANNER_COVER" />
    
    <div class="claims-block" ref="block1Ref">
      <div class="block-header yinhao">
        <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block1Title }}</span>
        <span class="desc" v-html="Utils.presetHtmlText(block1Desc)" />
      </div>
      <div class="block1-body">
        <div class="block-body-content">
          <div class="item" :class="{ active: item?.name == block1ListCurItem?.name }" v-for="(item, index) in block1List" :key="index" @click.stop="item.action">
            <Icon :name="item.icon" size="170" />
            <div class="title"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ item?.name }}</span></div>
            <span class="desc" v-html="Utils.presetHtmlText(item?.desc)" />
            <div class="checkmore">
              <Icon :name="item?.type == 'customerservice' ? 'contactonline-blue' : 'checkmore'" size="24" />
              <span :class="{ ffen: getLocalLangCode() != 'zh' }">{{item?.btntxt}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </session>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import * as Utils from '@/assets/utils';
  import Banner from '@/mobile/components/banner/index.vue';
  import TopNavs from '@/components/topnavs/index.vue';
  import Icon from '@/components/icon/index.vue';
  import Footer from '@/mobile/components/footer/index.vue';
  import Header from '@/mobile/components/header/index.vue';

  // imgs
  import IMG_BANNER_COVER from './images/cover.png';
  import IMG_BLOCK1_1 from './images/block1-1.png';
  import { LOCAL, getLocalLangCode } from '@/assets/lang';

  // banner
  const bannerTitle = ref('')
  const bannerContent = ref('')
  const bannerInit = () => {
    bannerTitle.value = LOCAL('claims_claims');
    bannerContent.value = LOCAL('claims_claims_desc');
  }
  onMounted(() => {
    bannerInit()
  });

  // 合作伙伴
  const block1Title = ref('');
  const block1Desc = ref('');
  const block1List = ref([]);
  const block1ListCurItem = ref(null);
  const block1ListTab = (index = 0) => {
    block1ListCurItem.value = block1List.value[index];
  }
  const block1Init = () => {
    block1Title.value = LOCAL('claims_application_inquiry');
    block1Desc.value = LOCAL('claims_application_inquiry_desc');
    block1List.value = [
      { 
        icon: 'onlineservice-blue', 
        name: LOCAL('claims_application_inquiry_method1_title'), 
        btntxt: LOCAL('claims_application_inquiry_login'),
        action: () => Utils.loginDialogToggle(true),
        desc: LOCAL('claims_application_inquiry_method1_desc')
      },
      { 
        icon: 'customerservice-blue', 
        name: LOCAL('claims_application_inquiry_method2_title'), 
        btntxt: LOCAL('contact'),
        action: () => Utils.toTargetPage('/contactus'),
        type: 'customerservice',
        desc: LOCAL('claims_application_inquiry_method2_desc') 
      },
    ]
  }
  onMounted(() => {
    block1Init();
    block1ListTab();
  })
</script>

<style scoped lang="less">
  @import "index.less";
</style>
